import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useQuery } from "@tanstack/react-query";

import { isRetailerALockedAccount } from "shared/retailer-helpers";
import { getUserRetailer } from "store/selectors/user";
import userAPI from "api/user-api";

export const useDashboardStats = () => {
  const retailer = useSelector(getUserRetailer);

  const isLockedAccount = useMemo(() => {
    if (isEmpty(retailer)) {
      return false;
    }

    return isRetailerALockedAccount({ retailer });
  }, [retailer]);

  return {
    isLockedAccount
  };
};

export const useRetailerData = () => useQuery(["retailerData"], async () => {
    const { value_listed, recent_listing_date } = await userAPI.fetchUserData();
    return {
      inventoryListedValue: value_listed,
      recentListingDate: recent_listing_date
    };
  });
